import { useSelector } from 'react-redux';
import { CustomProvider, TreePicker } from 'rsuite';
import { TreePickerCompProps } from '../../Interfaces/Props';
import { IRootState } from '../../Storage/Redux/store';
import { IconCaretDown, IconFile, IconFolder } from '../Icon';

const TreePickerComp = (props: TreePickerCompProps) => {
  const Theme =
    useSelector((state: IRootState) => state.themeConfig.theme) === 'dark'
      ? 'dark'
      : 'light';

  return (
    <CustomProvider theme={Theme}>
      <TreePicker
        name={props.name}
        data={props.options}
        value={props.value}
        placeholder={props.placeholder ?? 'Select...'}
        cleanable={props.cleanable ?? false}
        defaultExpandAll={!!props.defaultExpandAll}
        defaultExpandItemValues={props.defaultExpandNodes}
        disabled={props.disable}
        disabledItemValues={props.disableItems}
        loading={props.loading}
        onChange={props.onChange}
        onSelect={props.onSelect}
        open={props.open}
        searchable={props.searchable ?? true}
        size={props.size}
        treeHeight={props.height}
        style={props.style}
        className={props.className}
        popupStyle={props.popupStyle}
        popupClassName={props.popupClassName}
        placement={props.placement ?? 'autoVertical'}
        onExpand={props.onExpand}
        renderTreeIcon={(node, expandable) => {
          if (props.renderTreeIcon) {
            return props.renderTreeIcon(node, expandable);
          } else {
            return (
              <IconCaretDown
                className={`w-5 h-5 text-primary dark:text-blue-400 inline relative ml-4 mr-3 ${expandable && 'rotate-180'}`}
              />
            );
          }
        }}
        renderTreeNode={(node) => {
          if (props.renderTreeNode) {
            return props.renderTreeNode(node);
          } else {
            return (
              <>
                {node.children ? (
                  <IconFolder
                    fill
                    duotone={false}
                    className="inline size-5 relative ltr:mr-2 rtl:ml-2 text-amber-400"
                  />
                ) : (
                  <IconFile
                    duotone
                    className="inline size-5 relative ltr:mr-2 rtl:ml-2 text-primary dark:text-cyan-400"
                  />
                )}
                <span className="dark:text-slate-300">{node.label}</span>
              </>
            );
          }
        }}
      />
    </CustomProvider>
  );
};

export default TreePickerComp;
